module.exports = __webpack_public_path__ + "img/teeth-43.7c068ae8.png";